import * as Yup from "yup";

export const backgroundChecksValidationSchema = Yup.object().shape({
  instructions: Yup.string()
});
